import App from '../App'
import { FIN_FUNCTION_SCOPE, FIN_VARIANT } from './config'

const FIN_PRESETS = {
  lockedFunctionScope: FIN_FUNCTION_SCOPE,
  showPlatformSelector: true,
  variant: FIN_VARIANT,
} as const

/**
 * Finance variant root, mounted at the /finance subpath.
 *
 * Supplies presets to the shared App rather than forking its route table, so a
 * route added to App exists at /finance automatically and the two can't drift.
 */
export default function FinApp() {
  return <App outsideInProps={FIN_PRESETS} insideOutProps={FIN_PRESETS} />
}
